import { FlexBox, Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { getRatingResult } from '../../lib/utils'

export const RatingsGridX = () => {
  const { colors } = useTheme()
  const stats = useStats((s) => s.stats)
  const { ratings } = getRatingResult(stats)
  const itemCount = ratings.length

  return (
    <div
      className={css`
        margin-top: 4px;
        display: grid;
        grid-template-columns: repeat(${ratings.length}, 1fr);
        gap: 10px;
        position: relative;
        opacity: 0.5;
      `}
    >
      {ratings?.map((r, i) => {
        const showLabel = () => {
          if (itemCount < 10) return true
          return itemCount < 15 ? r.rating % 0.25 === 0 : r.rating % 0.5 === 0
        }
        const showStar = itemCount < 10 || r.rating % 1 === 0

        return (
          <FlexBox
            key={i}
            className={css`
              width: 100%;
            `}
            justifyContent="center"
          >
            <FlexBox
              className={css`
                gap: 2px;
                position: relative;
              `}
              flexDirection="column"
              alignItems="center"
            >
              <span
                className={css`
                  width: 1px;
                  height: 2px;
                  background-color: ${colors.uiWhite};
                `}
              />
              {showLabel() ? (
                <FlexBox
                  className={css`
                    gap: 2px;
                    position: absolute;
                    top: 3px;
                    left: 50%;
                    transform: translateX(-50%);
                  `}
                  alignItems="center"
                >
                  <Text
                    type="label"
                    sizing="S"
                    weight="500"
                    color={colors.uiWhite}
                  >
                    {`${r.rating}`}
                  </Text>
                  {showStar ? (
                    <Icon
                      className={css`
                        width: 9px;
                      `}
                      type="star-solid"
                      fill={colors.uiWhite}
                    />
                  ) : null}
                </FlexBox>
              ) : null}
            </FlexBox>
          </FlexBox>
        )
      })}
    </div>
  )
}
